import React from 'react';
import { observer } from 'mobx-react-lite';
import { AppLink as Link } from '@components/AppLink'
import { Icon } from '../Icon';
import { useStore } from '@store/StoreProvider';

export const PrivacySection: React.FC = observer(() => {
  const { i18n } = useStore();
  void i18n.language;
  void i18n.version;

  const cards = [
    {
      icon: 'ic-lock',
      title: 'Шифрование канала',
      text: 'Весь трафик между виджетом, ботом и пультом идёт только по защищённому соединению.',
    },
    {
      icon: 'ic-ban',
      title: 'Ноль лишних данных',
      text: 'Не просим документы, не собираем профили, не отдаём ничего рекламным сетям и брокерам.',
    },
    {
      icon: 'ic-shield-check',
      title: 'Пароль не восстановим',
      text: 'Пароли хранятся необратимыми хешами. Сообщить его не сможем ни мы, ни кто-либо ещё.',
    },
    {
      icon: 'ic-users',
      title: 'Доступ по участию',
      text: 'Оператор видит только каналы, к которым привязан, и диалоги, в которых участвовал.',
    },
  ];

  const links = [
    {
      to: '/status',
      icon: 'ic-bolt',
      title: 'Статус сервиса',
      live: true,
      text: 'Состояние каждого компонента и история инцидентов — в реальном времени.',
    },
    {
      to: '/offer',
      icon: 'ic-shield',
      title: 'Условия без сюрпризов',
      text: 'Оферта и политика опубликованы целиком. Что храним и сколько — написано прямо.',
    },
    {
      to: '/knowledge-base',
      icon: 'ic-message',
      title: i18n.t('nav.knowledge_base'),
      text: 'Подключение виджета и бота, настройка команды, работа с архивом.',
    },
  ];

  return (
    <section id="privacy" className="relative pt-14 sm:pt-20 pb-10 sm:pb-14 overflow-hidden">
      <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <div className="reveal inline-flex items-center gap-2 text-xs font-semibold text-brand2 uppercase tracking-widest mb-4">
            <span className="w-8 h-px bg-brand2" /> Приватность{' '}
            <span className="w-8 h-px bg-brand2" />
          </div>
          <h2 className="reveal text-3xl sm:text-5xl font-extrabold">
            Данных нет — <span className="text-gradient">нечего терять</span>
          </h2>
          <p className="reveal mt-3 text-slate-400">
            Приватность здесь не режим в настройках, а то, как устроена платформа.
          </p>
        </div>

        <div data-stagger className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {cards.map((c) => (
            <div key={c.title} className="reveal rounded-2xl border border-white/10 bg-panel/40 p-6 h-full flex flex-col">
              <div className="ic-badge mb-4">
                <Icon id={c.icon} className="ic" />
              </div>
              <h3 className="font-bold mb-2">{c.title}</h3>
              <p className="text-sm text-slate-400">{c.text}</p>
            </div>
          ))}
        </div>

        <div className="reveal mt-4 rounded-2xl border border-white/10 bg-panel/40 p-6 sm:p-7 flex flex-col sm:flex-row sm:items-center gap-5">
          <div className="ic-badge shrink-0">
            <Icon id="ic-globe" className="ic" />
          </div>
          <div className="flex-1">
            <h3 className="font-bold mb-1.5">Инфраструктура в Европе</h3>
            <p className="text-sm text-slate-400">
              Серверы размещены в Европе. Что храним, сколько и кому передаём — описано в политике
              конфиденциальности; запросы третьих лиц рассматриваем строго в рамках закона.
            </p>
          </div>
          <Link
            to="/policy"
            className="shrink-0 inline-flex items-center gap-2 px-5 py-3 rounded-2xl border border-white/15 text-sm font-semibold hover:bg-white/5 transition"
          >
            Политика <Icon id="ic-arrow-right" className="ic ic-sm" />
          </Link>
        </div>

        <div data-stagger className="mt-4 grid sm:grid-cols-3 gap-4">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              className="reveal group rounded-2xl border border-white/10 bg-panel/40 p-6 flex items-start gap-4 hover:border-white/20 transition"
            >
              <span className="ic-badge shrink-0">
                <Icon id={l.icon} className="ic" />
              </span>
              <span className="min-w-0">
                <span className="flex items-center gap-2 font-bold">
                  {l.title}
                  {l.live ? (
                    <span className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-[10px] font-bold bg-emerald-500/12 text-emerald-400 border border-emerald-500/25">
                      <span className="w-1.5 h-1.5 rounded-full bg-current" />
                      live
                    </span>
                  ) : null}
                </span>
                <span className="block mt-1.5 text-sm text-slate-400">{l.text}</span>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
});
